import { render, staticRenderFns } from "./ProjectEvidencesRevisionTab.vue?vue&type=template&id=7eded7c6&"
import script from "./ProjectEvidencesRevisionTab.vue?vue&type=script&lang=js&"
export * from "./ProjectEvidencesRevisionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports